module.exports = __webpack_public_path__ + "static/tesitelova-dfe1e6864232aad397fb715557263e85.jpg";